import { SelectionControl } from './SelectionControl';
import { colors } from '@cobliteam/ui/theme';
import { withStyles } from '@material-ui/core/styles';
import MuiSwitch, { type SwitchProps as MuiSwitchProps } from '@material-ui/core/Switch';

interface SwitchProps extends MuiSwitchProps {
  label?: string;
}

export const BaseSwitch = withStyles({
  root: {
    width: 35,
    height: 21,
    padding: 0,
  },
  switchBase: {
    width: 21,
    height: 21,
    padding: 0,

    '&$checked': {
      transform: 'translateX(14px)',

      '& + $track': {
        opacity: 1,
        backgroundColor: colors.success[9],
      },

      '&$disabled + $track': {
        backgroundColor: colors.success[4],
      },
    },

    '&$disabled + $track': {
      opacity: 1,
      backgroundColor: colors.gray[4],
    },
  },
  checked: {},
  disabled: {},
  thumb: {
    width: 19,
    height: 19,
    color: colors.white.DEFAULT,
  },
  track: {
    width: 35,
    height: 21,
    borderRadius: 20,
    backgroundColor: colors.gray[7],
    opacity: 1,
  },
  input: {
    '&[type="checkbox"]': {
      margin: 0,
    },
  },
})(MuiSwitch);

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const Switch = (props: SwitchProps) => {
  const { label, className, ...otherProps } = props;

  return <SelectionControl className={className} label={label} control={<BaseSwitch disableRipple {...otherProps} />} />;
};
